import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Breadcrumb } from '../models/breadcrumb';
import { IBreadcrumbsService } from '../interfaces/breadcrumbs-service.interface';

@Injectable()
export class BreadcrumbsService implements IBreadcrumbsService {

  private _breadcrumbs: Breadcrumb[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this._breadcrumbs = this.breadcrumbsTemplate;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const navigationEnd = event as NavigationEnd;
        if (navigationEnd && navigationEnd.url === '/') {
          this._breadcrumbs = this.breadcrumbsTemplate;
        }
        this.buildBreadcrumbs(this.activatedRoute.root);
      }
    });
  }

  get hasActiveBreadcrumbs() {
    return this.breadcrumbs.findIndex(item => item.isActive) > -1 ? true : false;
  }

  get breadcrumbs(): Breadcrumb[] {
    return this._breadcrumbs;
  }

  buildBreadcrumbs(route: ActivatedRoute) {
    if (route.firstChild) {
      return this.buildBreadcrumbs(route.firstChild);
    }

    const activeItem = route.routeConfig && route.routeConfig.data ? route.routeConfig.data['breadcrumb'] : null;

    if (!(activeItem && activeItem.sequence > -1 && activeItem.sequence < this._breadcrumbs.length)) {
      this._breadcrumbs.forEach(item => item.isActive = false);
    } else {
      for (let i = 0; i < this._breadcrumbs.length; i++) {
        this._breadcrumbs[i].isActive = i <= activeItem.sequence;
        if (i === activeItem.sequence) {
          this._breadcrumbs[i].label = activeItem.title;
          this._breadcrumbs[i].url = activeItem.url;
        }
      }
    }
  }

  get breadcrumbsTemplate(): Breadcrumb[] {
    const breadcrumbs = Array<Breadcrumb>();
    this._searchBreadcrumbs(breadcrumbs, this.router.config);
    return breadcrumbs.sort((a, b) => a.sequence - b.sequence);
  }

  private _searchBreadcrumbs(breadcrumbs: Breadcrumb[], routeConfigs) {
    if (!routeConfigs) {
      return;
    }
    routeConfigs.forEach(element => {
      if (element.data && element.data.breadcrumb && element.data.breadcrumb.sequence > -1) {
        if (breadcrumbs.findIndex(x => x.sequence === element.data.breadcrumb.sequence) < 0) {
          const newBreadcrumb = new Breadcrumb(
            element.data.breadcrumb.title,
            '',
            false,
            element.data.breadcrumb.sequence
          );
          breadcrumbs.push(newBreadcrumb);
        }
      }
      if (element.children) {
        this._searchBreadcrumbs(breadcrumbs, element.children);
      }
    });
  }

  setBreadcrumbLevelUrl(level: number, url: string): void {
    if (this._breadcrumbs && this._breadcrumbs.length > level) {
      this._breadcrumbs[level].url = url;
    }
  }
}
